// import React, { useRef, useState } from "react";
// import { Link, useLocation } from "react-router-dom";
// import logo from "../images/logo.png";
// import { useAuth } from "../store/authProvider";
// import { motion, AnimatePresence } from "framer-motion";
// import MobileMenuBtn from "./MobileMenuBtn";
// import { useQuery } from "@tanstack/react-query";
// import Client from "../utils/client";

// const AppBar = () => {
//   // Fetch unread messages count
//   const { data: unreadCount = 0 } = useQuery({
//     queryKey: ["unreadMessages"],
//     queryFn: async () => {
//       const response = await Client.get("/messages/unread-count");
//       return response.data.unreadCount;
//     },
//     refetchInterval: 5000, // Poll every 5 seconds
//   });
//   const pages = [
//     {
//       name: "الرئيسية",
//       number: 0,
//       role: "/",
//       query: "/",
//     },
//     {
//       name: "الأسعار",
//       number: 2,
//       role: "prices",
//       query: "/home/prices",
//     },
//     {
//       name: "المحاصيل",
//       number: 1,
//       role: "crops",
//       subMenu: [
//         {
//           name: "العروض",
//           role: "crops",
//           query: "/home/cropsOffers",
//         },
//         {
//           name: "الطلبات",
//           role: "crops",
//           query: "/home/cropsBuy",
//         },
//         {
//           name: "المزاد",
//           role: "crops",
//           query: "/home/cropsAuction",
//         },
//       ],
//     },
//     {
//       name: " الخدمات",
//       number: 5,
//       role: "service",
//       subMenu: [
//         {
//           name: "العروض",
//           role: "service",
//           query: "/home/services",
//         },
//         {
//           name: "الطلبات",
//           role: "service",
//           query: "/home/servicesOrders",
//         },
//       ],
//     },
//     {
//       name: "مدخلات الإنتاج",
//       role: "products",
//       number: 3,
//       subMenu: [
//         {
//           name: "العروض",
//           role: "products",
//           query: "/home/productsOffers",
//         },
//         {
//           name: "الطلبات",
//           role: "products",
//           query: "/home/productsOrders",
//         },
//       ],
//     },
//     {
//       name: "مرشد محصول",
//       number: 8,
//       role: "guide",
//       query: "/home/mahsool-guide",
//     },
//     {
//       name: "الطقس",
//       number: 9,
//       role: "weather",
//       query: "/home/weather",
//     },
//     {
//       name: "حسابي",
//       number: 7,
//       role: "profile",
//       query: "/home/profile",
//       isAuth: true,
//     },
//     {
//       name: "مساهمة ثبات",
//       number: 7,
//       role: "profile",
//       query: "/home/in-kind",
//       isAuth: true,
//     },
//     {
//       name: "المدونة",
//       number: 6,
//       role: "blogs",
//       query: "/home/blogs",
//     },
//     {
//       name: "المعرض",
//       number: 6,
//       role: "gallery",
//       query: "/home/gallery",
//     },
//     {
//       name: "من نحن",
//       number: 4,
//       role: "about",
//       query: "/home/about",
//     },
//   ];

//   const { isAuth } = useAuth();
//   const [page, setPage] = useState(0);
//   const [cropsMenu, setCropsMenu] = useState(false);
//   const [servicesMenu, setServicesMenu] = useState(false);
//   const [productsMenu, setProductsMenu] = useState(false);
//   const [mobileMenu, setMobileMenu] = useState(false);
//   const [hoveredItem, setHoveredItem] = useState(null);
//   const hideTimeoutRef = useRef(null);

//   const handleMouseEnter = (index) => {
//     clearTimeout(hideTimeoutRef.current);
//     setHoveredItem(index);
//   };

//   const handleMouseLeave = () => {
//     hideTimeoutRef.current = setTimeout(() => {
//       setHoveredItem(null);
//     }, 200); // Delay (200ms) before hiding
//   };

//   const path = useLocation().pathname;
//   const scrollRef = useRef(null);

//   const logout = () => {
//     localStorage.removeItem("token");
//     localStorage.removeItem("permissions");
//     localStorage.removeItem("user_id");
//     localStorage.removeItem("auth");
//     localStorage.removeItem("type");
//     localStorage.removeItem("cooperativeType");
//     window.location.reload();
//   };

//   const container = {
//     hidden: { opacity: 0 },
//     visible: {
//       opacity: 1,
//       transition: {
//         delayChildren: 0.2,
//         staggerChildren: 0.1,
//       },
//     },
//   };

//   const item = {
//     hidden: { x: 20, opacity: 0 },
//     visible: {
//       x: 0,
//       opacity: 1,
//     },
//   };

//   return (
//     <>
//       {/* Desktop Header */}
//       <div className="lg:flex md:flex flex-col w-screen hidden sticky top-0 z-50">
//         <div className="w-full py-3 px-10 backdrop-blur-md bg-white/90 shadow-sm border-b border-gray-100">
//           <div className="flex flex-row-reverse justify-between items-center max-w-7xl mx-auto">
//             {/* Logo */}
//             <Link to={"/"} className="flex items-center">
//               <img src={logo} alt="Logo" className="w-16 h-16 object-contain" />
//             </Link>

//             {/* Navigation Links */}
//             <div dir="rtl" className="flex items-center gap-1">
//               {pages.map((e, index) => (
//                 <div
//                   key={index}
//                   className="relative"
//                   onMouseEnter={() => handleMouseEnter(index)}
//                   onMouseLeave={handleMouseLeave}
//                 >
//                   <Link to={e.query} key={e.number}>
//                     <div
//                       className={`px-3 py-2 text-sm font-medium transition-all duration-300 rounded-lg ${path === e.role || path.replaceAll("/", "").includes(e.role)
//                         ? "text-primary bg-primary/10"
//                         : "text-gray-600 hover:text-primary hover:bg-gray-50"
//                         } ${e.isAuth && !isAuth ? "hidden" : ""}`}
//                     >
//                       <div className="flex items-center gap-1">
//                         {e.name}
//                         {e.subMenu && (
//                           <svg
//                             className="w-4 h-4"
//                             viewBox="0 0 20 20"
//                             fill="currentColor"
//                           >
//                             <path
//                               fillRule="evenodd"
//                               d="M5.23 7.21a.75.75 0 011.06.02L10 11.168l3.71-3.938a.75.75 0 111.08 1.04l-4.25 4.5a.75.75 0 01-1.08 0l-4.25-4.5a.75.75 0 01.02-1.06z"
//                               clipRule="evenodd"
//                             />
//                           </svg>
//                         )}
//                         {e.name === "حسابي" && unreadCount > 0 && (
//                           <span className="absolute top-1 right-0 w-2 h-2 bg-red-500 rounded-full animate-pulse"></span>
//                         )}
//                       </div>
//                     </div>
//                   </Link>

//                   {/* Hover underline effect */}
//                   {(hoveredItem === index || path === e.role || path.replaceAll("/", "").includes(e.role)) && (
//                     <motion.div
//                       layoutId="navUnderline"
//                       className="absolute bottom-0 left-0 right-0 h-0.5 bg-primary"
//                       initial={false}
//                       transition={{ type: "spring", bounce: 0.2, duration: 0.6 }}
//                     />
//                   )}

//                   {/* Submenu */}
//                   {e.subMenu && hoveredItem === index && (
//                     <motion.div
//                       initial={{ opacity: 0, y: 10 }}
//                       animate={{ opacity: 1, y: 0 }}
//                       exit={{ opacity: 0, y: 10 }}
//                       transition={{ duration: 0.2 }}
//                       className="absolute right-0 mt-2 w-48 origin-top-right rounded-xl bg-white shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none z-50"
//                       onMouseEnter={() => setHoveredItem(index)} // Keep open when hovering submenu
//                       onMouseLeave={() => setTimeout(() => setHoveredItem(null), 200)}
//                     >
//                       <div className="py-1">
//                         {e.subMenu.map((subItem, subIndex) => (
//                           <Link
//                             to={subItem.query}
//                             key={subIndex}
//                             className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-50 hover:text-primary transition-colors"
//                           >
//                             {subItem.name}
//                           </Link>
//                         ))}
//                       </div>
//                     </motion.div>
//                   )}
//                 </div>
//               ))}
//             </div>

//             {/* Auth Button */}
//             <div className="flex items-center">
//               {!isAuth ? (
//                 <Link to={"/signin"}>
//                   <button className="px-4 py-2 text-sm font-medium text-white bg-primary rounded-lg hover:bg-primary/90 transition-colors shadow-sm hover:shadow-md">
//                     تسجيل الدخول
//                   </button>
//                 </Link>
//               ) : (
//                 <button
//                   onClick={() => logout()}
//                   className="px-4 py-2 text-sm font-medium text-primary border border-primary rounded-lg hover:bg-primary/10 transition-colors"
//                 >
//                   تسجيل الخروج
//                 </button>
//               )}
//             </div>
//           </div>
//         </div>
//       </div>

//       {/* Mobile Header */}
//       <nav dir="rtl" className="lg:hidden md:hidden sticky top-0 z-50 bg-white shadow-sm border-b border-gray-100 backdrop-blur-md bg-white/90">
//         <div className="container mx-auto px-4 py-3">
//           <div className="flex items-center justify-between">
//             <Link to="/" className="flex items-center">
//               <img src={logo} className="w-16 h-16 object-contain" alt="Logo" />
//             </Link>

//             <MobileMenuBtn menu={mobileMenu} setMenu={setMobileMenu} />
//           </div>

//           <AnimatePresence>
//             {mobileMenu && (
//               <motion.div
//                 variants={container}
//                 initial="hidden"
//                 animate="visible"
//                 exit="hidden"
//                 className="w-full mt-4"
//               >
//                 <ul className="space-y-2">
//                   {pages.map((e, index) => (
//                     <motion.li
//                       variants={item}
//                       key={index}
//                       className="border-b border-gray-100 last:border-0"
//                     >
//                       <div
//                         className={`px-4 py-3 rounded-lg transition-colors ${path === e.role || path.replaceAll("/", "").includes(e.role)
//                           ? "bg-primary/10 text-primary"
//                           : "text-gray-600"
//                           } ${e.isAuth && !isAuth ? "hidden" : ""}`}
//                         onClick={() => {
//                           if (!e.subMenu) setMobileMenu(false);
//                           else if (e.name === "المحاصيل") setCropsMenu(!cropsMenu);
//                           else if (e.number === 5) setServicesMenu(!servicesMenu);
//                           else if (e.number === 3) setProductsMenu(!productsMenu);
//                         }}
//                       >
//                         <Link to={e.subMenu ? '#' : e.query} className="flex justify-between items-center">
//                           <span className="font-medium">{e.name}</span>
//                           {e.subMenu && (
//                             <svg
//                               className={`w-5 h-5 transition-transform ${(e.name === "المحاصيل" && cropsMenu) ||
//                                 (e.number === 5 && servicesMenu) ||
//                                 (e.number === 3 && productsMenu)
//                                 ? "rotate-180"
//                                 : ""
//                                 }`}
//                               viewBox="0 0 20 20"
//                               fill="currentColor"
//                             >
//                               <path
//                                 fillRule="evenodd"
//                                 d="M5.23 7.21a.75.75 0 011.06.02L10 11.168l3.71-3.938a.75.75 0 111.08 1.04l-4.25 4.5a.75.75 0 01-1.08 0l-4.25-4.5a.75.75 0 01.02-1.06z"
//                                 clipRule="evenodd"
//                               />
//                             </svg>
//                           )}
//                         </Link>
//                       </div>

//                       {/* Mobile Submenus */}
//                       <AnimatePresence>
//                         {((e.name === "المحاصيل" && cropsMenu) ||
//                           (e.number === 5 && servicesMenu) ||
//                           (e.number === 3 && productsMenu)) && (
//                             <motion.div
//                               initial={{ height: 0, opacity: 0 }}
//                               animate={{ height: 'auto', opacity: 1 }}
//                               exit={{ height: 0, opacity: 0 }}
//                               transition={{ duration: 0.2 }}
//                               className="pl-6 overflow-hidden"
//                             >
//                               {e.subMenu?.map((subItem, subIndex) => (
//                                 <Link
//                                   to={subItem.query}
//                                   key={subIndex}
//                                   onClick={() => setMobileMenu(false)}
//                                   className={`block px-4 py-2 text-sm rounded-lg my-1 ${path === subItem.role || path.replaceAll("/", "").includes(subItem.role)
//                                     ? "bg-primary/10 text-primary"
//                                     : "text-gray-600 hover:bg-gray-50"
//                                     }`}
//                                 >
//                                   {subItem.name}
//                                 </Link>
//                               ))}
//                             </motion.div>
//                           )}
//                       </AnimatePresence>
//                     </motion.li>
//                   ))}

//                   <motion.li variants={item} className="pt-2">
//                     {!isAuth ? (
//                       <Link to="/signin" onClick={() => setMobileMenu(false)}>
//                         <button className="w-full px-4 py-2 text-sm font-medium text-white bg-primary rounded-lg hover:bg-primary/90 transition-colors">
//                           تسجيل الدخول
//                         </button>
//                       </Link>
//                     ) : (
//                       <button
//                         onClick={() => {
//                           logout();
//                           setMobileMenu(false);
//                         }}
//                         className="w-full px-4 py-2 text-sm font-medium text-primary border border-primary rounded-lg hover:bg-primary/10 transition-colors"
//                       >
//                         تسجيل الخروج
//                       </button>
//                     )}
//                   </motion.li>
//                 </ul>
//               </motion.div>
//             )}
//           </AnimatePresence>
//         </div>
//       </nav>
//     </>
//   );
// };

// export default AppBar;
import React, { useRef, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import logo from "../images/logo.png";
import { useAuth } from "../store/authProvider";
import { motion, AnimatePresence } from "framer-motion";
import MobileMenuBtn from "./MobileMenuBtn";
import { useQuery } from "@tanstack/react-query";
import Client from "../utils/client";

const AppBar = () => {
  const { t } = useTranslation();

  // Fetch unread messages count
  const { data: unreadCount = 0 } = useQuery({
    queryKey: ["unreadMessages"],
    queryFn: async () => {
      const response = await Client.get("/messages/unread-count");
      return response.data.unreadCount;
    },
    refetchInterval: 5000, // Poll every 5 seconds
  });

  const pages = [
    {
      nameKey: "common.home",
      number: 0,
      role: "/",
      query: "/",
    },
    {
      nameKey: "common.prices",
      number: 2,
      role: "prices",
      query: "/home/prices",
    },
    {
      nameKey: "common.crops",
      number: 1,
      role: "crops",
      subMenu: [
        {
          nameKey: "common.offers",
          role: "crops",
          query: "/home/cropsOffers",
        },
        {
          nameKey: "common.orders",
          role: "crops",
          query: "/home/cropsBuy",
        },
        {
          nameKey: "common.auction",
          role: "crops",
          query: "/home/cropsAuction",
        },
      ],
    },
    {
      nameKey: "common.services",
      number: 5,
      role: "service",
      subMenu: [
        {
          nameKey: "common.offers",
          role: "service",
          query: "/home/services",
        },
        {
          nameKey: "common.orders",
          role: "service",
          query: "/home/servicesOrders",
        },
      ],
    },
    {
      nameKey: "common.products",
      role: "products",
      number: 3,
      subMenu: [
        {
          nameKey: "common.offers",
          role: "products",
          query: "/home/productsOffers",
        },
        {
          nameKey: "common.orders",
          role: "products",
          query: "/home/productsOrders",
        },
      ],
    },
    {
      nameKey: "common.guide",
      number: 8,
      role: "guide",
      query: "/home/mahsool-guide",
    },
    {
      nameKey: "common.weather",
      number: 9,
      role: "weather",
      query: "/home/weather",
    },
    {
      nameKey: "common.profile",
      number: 7,
      role: "profile",
      query: "/home/profile",
      isAuth: true,
    },
    {
      nameKey: "common.contribution",
      number: 7,
      role: "profile",
      query: "/home/in-kind",
      isAuth: true,
    },
    {
      nameKey: "common.blog",
      number: 6,
      role: "blogs",
      query: "/home/blogs",
    },
    {
      nameKey: "common.gallery",
      number: 6,
      role: "gallery",
      query: "/home/gallery",
    },
    {
      nameKey: "common.about",
      number: 4,
      role: "about",
      query: "/home/about",
    },
  ];

  const { isAuth } = useAuth();
  const [page, setPage] = useState(0);
  const [cropsMenu, setCropsMenu] = useState(false);
  const [servicesMenu, setServicesMenu] = useState(false);
  const [productsMenu, setProductsMenu] = useState(false);
  const [mobileMenu, setMobileMenu] = useState(false);
  const [hoveredItem, setHoveredItem] = useState(null);
  const hideTimeoutRef = useRef(null);

  const handleMouseEnter = (index) => {
    clearTimeout(hideTimeoutRef.current);
    setHoveredItem(index);
  };

  const handleMouseLeave = () => {
    hideTimeoutRef.current = setTimeout(() => {
      setHoveredItem(null);
    }, 200); // Delay (200ms) before hiding
  };

  const path = useLocation().pathname;
  const scrollRef = useRef(null);

  const logout = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("permissions");
    localStorage.removeItem("user_id");
    localStorage.removeItem("auth");
    localStorage.removeItem("type");
    localStorage.removeItem("cooperativeType");
    window.location.reload();
  };

  const container = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        delayChildren: 0.2,
        staggerChildren: 0.1,
      },
    },
  };

  const item = {
    hidden: { x: 20, opacity: 0 },
    visible: {
      x: 0,
      opacity: 1,
    },
  };

  return (
    <>
      {/* Desktop Header */}
      <div className="lg:flex md:flex flex-col w-screen hidden sticky top-0 z-50">
        <div className="w-full py-3 px-10 backdrop-blur-md bg-white/90 shadow-sm border-b border-gray-100">
          <div className="flex flex-row-reverse justify-between items-center max-w-7xl mx-auto">

            {/* Auth Button */}
            <div className="flex items-center">
              {!isAuth ? (
                <Link to={"/signin"}>
                  <button className="px-4 py-2 text-sm font-medium text-white bg-primary rounded-lg hover:bg-primary/90 transition-colors shadow-sm hover:shadow-md">
                    {t("common.login")}
                  </button>
                </Link>
              ) : (
                <button
                  onClick={() => logout()}
                  className="px-4 py-2 text-sm font-medium text-primary border border-primary rounded-lg hover:bg-primary/10 transition-colors"
                >
                  {t("common.logout")}
                </button>
              )}
            </div>

            {/* Navigation Links */}
            <div className="flex items-center gap-1">
              {pages.map((e, index) => (
                <div
                  key={index}
                  className="relative"
                  onMouseEnter={() => handleMouseEnter(index)}
                  onMouseLeave={handleMouseLeave}
                >
                  <Link to={e.query} key={e.number}>
                    <div
                      className={`px-3 py-2 text-sm font-medium transition-all duration-300 rounded-lg ${path === e.role || path.replaceAll("/", "").includes(e.role)
                          ? "text-primary bg-primary/10"
                          : "text-gray-600 hover:text-primary hover:bg-gray-50"
                        } ${e.isAuth && !isAuth ? "hidden" : ""}`}
                    >
                      <div className="flex items-center gap-1">
                        {t(e.nameKey)}
                        {e.subMenu && (
                          <svg
                            className="w-4 h-4"
                            viewBox="0 0 20 20"
                            fill="currentColor"
                          >
                            <path
                              fillRule="evenodd"
                              d="M5.23 7.21a.75.75 0 011.06.02L10 11.168l3.71-3.938a.75.75 0 111.08 1.04l-4.25 4.5a.75.75 0 01-1.08 0l-4.25-4.5a.75.75 0 01.02-1.06z"
                              clipRule="evenodd"
                            />
                          </svg>
                        )}
                        {e.nameKey === "common.profile" && unreadCount > 0 && (
                          <span className="absolute top-1 right-0 w-2 h-2 bg-red-500 rounded-full animate-pulse"></span>
                        )}
                      </div>
                    </div>
                  </Link>

                  {/* Hover underline effect */}
                  {(hoveredItem === index || path === e.role || path.replaceAll("/", "").includes(e.role)) && (
                    <motion.div
                      layoutId="navUnderline"
                      className="absolute bottom-0 left-0 right-0 h-0.5 bg-primary"
                      initial={false}
                      transition={{ type: "spring", bounce: 0.2, duration: 0.6 }}
                    />
                  )}

                  {/* Submenu */}
                  {e.subMenu && hoveredItem === index && (
                    <motion.div
                      initial={{ opacity: 0, y: 10 }}
                      animate={{ opacity: 1, y: 0 }}
                      exit={{ opacity: 0, y: 10 }}
                      transition={{ duration: 0.2 }}
                      className="absolute right-0 mt-2 w-48 origin-top-right rounded-xl bg-white shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none z-50"
                      onMouseEnter={() => setHoveredItem(index)} // Keep open when hovering submenu
                      onMouseLeave={() => setTimeout(() => setHoveredItem(null), 200)}
                    >
                      <div className="py-1">
                        {e.subMenu.map((subItem, subIndex) => (
                          <Link
                            to={subItem.query}
                            key={subIndex}
                            className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-50 hover:text-primary transition-colors"
                          >
                            {t(subItem.nameKey)}
                          </Link>
                        ))}
                      </div>
                    </motion.div>
                  )}
                </div>
              ))}
            </div>

            {/* Logo */}
            <Link to={"/"} className="flex items-center">
              <img src={logo} alt="Logo" className="w-16 h-16 object-contain" />
            </Link>


          </div>
        </div>
      </div>

      {/* Mobile Header */}
      <nav dir="rtl" className="lg:hidden md:hidden sticky top-0 z-50 bg-white shadow-sm border-b border-gray-100 backdrop-blur-md bg-white/90">
        <div className="container mx-auto px-4 py-3">
          <div className="flex items-center justify-between">
            <Link to="/" className="flex items-center">
              <img src={logo} className="w-16 h-16 object-contain" alt="Logo" />
            </Link>

            <MobileMenuBtn menu={mobileMenu} setMenu={setMobileMenu} />
          </div>

          <AnimatePresence>
            {mobileMenu && (
              <motion.div
                variants={container}
                initial="hidden"
                animate="visible"
                exit="hidden"
                className="w-full mt-4"
              >
                <ul className="space-y-2">
                  {pages.map((e, index) => (
                    <motion.li
                      variants={item}
                      key={index}
                      className="border-b border-gray-100 last:border-0"
                    >
                      <div
                        className={`px-4 py-3 rounded-lg transition-colors ${path === e.role || path.replaceAll("/", "").includes(e.role)
                            ? "bg-primary/10 text-primary"
                            : "text-gray-600"
                          } ${e.isAuth && !isAuth ? "hidden" : ""}`}
                        onClick={() => {
                          if (!e.subMenu) setMobileMenu(false);
                          else if (e.nameKey === "common.crops") setCropsMenu(!cropsMenu);
                          else if (e.number === 5) setServicesMenu(!servicesMenu);
                          else if (e.number === 3) setProductsMenu(!productsMenu);
                        }}
                      >
                        <Link to={e.subMenu ? '#' : e.query} className="flex justify-between items-center">
                          <span className="font-medium">{t(e.nameKey)}</span>
                          {e.subMenu && (
                            <svg
                              className={`w-5 h-5 transition-transform ${(e.nameKey === "common.crops" && cropsMenu) ||
                                  (e.number === 5 && servicesMenu) ||
                                  (e.number === 3 && productsMenu)
                                  ? "rotate-180"
                                  : ""
                                }`}
                              viewBox="0 0 20 20"
                              fill="currentColor"
                            >
                              <path
                                fillRule="evenodd"
                                d="M5.23 7.21a.75.75 0 011.06.02L10 11.168l3.71-3.938a.75.75 0 111.08 1.04l-4.25 4.5a.75.75 0 01-1.08 0l-4.25-4.5a.75.75 0 01.02-1.06z"
                                clipRule="evenodd"
                              />
                            </svg>
                          )}
                        </Link>
                      </div>

                      {/* Mobile Submenus */}
                      <AnimatePresence>
                        {((e.nameKey === "common.crops" && cropsMenu) ||
                          (e.number === 5 && servicesMenu) ||
                          (e.number === 3 && productsMenu)) && (
                            <motion.div
                              initial={{ height: 0, opacity: 0 }}
                              animate={{ height: 'auto', opacity: 1 }}
                              exit={{ height: 0, opacity: 0 }}
                              transition={{ duration: 0.2 }}
                              className="pl-6 overflow-hidden"
                            >
                              {e.subMenu?.map((subItem, subIndex) => (
                                <Link
                                  to={subItem.query}
                                  key={subIndex}
                                  onClick={() => setMobileMenu(false)}
                                  className={`block px-4 py-2 text-sm rounded-lg my-1 ${path === subItem.role || path.replaceAll("/", "").includes(subItem.role)
                                      ? "bg-primary/10 text-primary"
                                      : "text-gray-600 hover:bg-gray-50"
                                    }`}
                                >
                                  {t(subItem.nameKey)}
                                </Link>
                              ))}
                            </motion.div>
                          )}
                      </AnimatePresence>
                    </motion.li>
                  ))}

                  <motion.li variants={item} className="pt-2">
                    {!isAuth ? (
                      <Link to="/signin" onClick={() => setMobileMenu(false)}>
                        <button className="w-full px-4 py-2 text-sm font-medium text-white bg-primary rounded-lg hover:bg-primary/90 transition-colors">
                          {t("common.login")}
                        </button>
                      </Link>
                    ) : (
                      <button
                        onClick={() => {
                          logout();
                          setMobileMenu(false);
                        }}
                        className="w-full px-4 py-2 text-sm font-medium text-primary border border-primary rounded-lg hover:bg-primary/10 transition-colors"
                      >
                        {t("common.logout")}
                      </button>
                    )}
                  </motion.li>
                </ul>
              </motion.div>
            )}
          </AnimatePresence>
        </div>
      </nav>
    </>
  );
};

export default AppBar;